module.exports = __webpack_public_path__ + "assets/img/The-Cricket-Academy.44d23385.png";